
import BannerContainer from '~/components/child/banner/BannerContainer.vue';
import TagContainer from '~/components/child/tag/TagContainer.vue';
import RecipeContainer from '~/components/child/recipe/RecipeContainer.vue';
import BrowseContainer from '~/components/child/browse/BrowseContainer.vue';
import ArticleChannelContainer from '~/components/child/article/ArticleChannelContainer.vue';
import BloggerRankingChannel from '~/components/child/blogger/BloggerRankingChannel.vue';
import ArticleHotContainer from '~/components/child/article/ArticleHotContainer.vue';
export default {
    name: "travel",
    components: { BannerContainer, TagContainer, RecipeContainer, BrowseContainer, ArticleChannelContainer, BloggerRankingChannel, ArticleHotContainer },
    head() {
        return {
            title: '職涯-PIXNET痞客邦',
            meta: [
                { hid: 'description', name: 'description', content: '痞客邦職涯頻道，有網友們提供的職涯資訊、實用的就業技巧和職場心得分享。不論你是準備找工作、轉職還是尋求晉升，這裡有各種寶貴的建議和專家見解等待你的探索。加入我們，與一群志同道合的人們共同探索職場世界，實現職涯夢想！' },
                { hid: 'og:description', name: 'og:description', property: 'og:description', content: '痞客邦職涯頻道，有網友們提供的職涯資訊、實用的就業技巧和職場心得分享。不論你是準備找工作、轉職還是尋求晉升，這裡有各種寶貴的建議和專家見解等待你的探索。加入我們，與一群志同道合的人們共同探索職場世界，實現職涯夢想！' },
                { hid: 'twitter:description', name: 'twitter:description', property: 'twitter:description', content: '痞客邦職涯頻道，有網友們提供的職涯資訊、實用的就業技巧和職場心得分享。不論你是準備找工作、轉職還是尋求晉升，這裡有各種寶貴的建議和專家見解等待你的探索。加入我們，與一群志同道合的人們共同探索職場世界，實現職涯夢想！' },
                { hid: 'keywords', name: 'keywords', content: '求職、職涯規劃、職場技巧、職業發展、升遷、職場競爭力、自我提升、轉職、職涯專業培訓、個人品牌、面試技巧、履歷撰寫、工作技能、領導力發展、創業、職業健康與幸福感、學習與成長、工作生涯規劃、行業洞察與趨勢、職場溝通技巧' },
                { hid: 'og:title', name: 'og:title', property: 'og:title', content: "職涯-PIXNET痞客邦"},
                { property: 'og:image', property: 'og:image', content: "https://www.pixnet.net/img/public/og/img_carrer_og.png"},
                { property: 'og:image:secure_url', property: 'og:image:secure_url', content: "https://www.pixnet.net/img/public/og/img_carrer_og.png"},
                { property: 'twitter:image', property: 'twitter:image', content: "https://www.pixnet.net/img/public/og/img_carrer_og.png"},
                { property: 'image', name: 'image', itemprop: 'image', content: "https://www.pixnet.net/img/public/og/img_carrer_og.png"},
            ],
            link: [
                { rel: 'canonical', href: 'https://www.pixnet.net/channel/career', key: "canonical"}
            ]
        }
    },
    jsonld() {
        return {
            "@context": " https://schema.org/",
            "@graph": [
                {
                    "@context":"https://schema.org",
                    "@type":"Organization",
                    "url":"https://www.pixnet.net",
                    "logo":"https://www.pixnet.net/img/public/og/img_carrer_og.png",
                    "name":"痞客邦",
                    "@id":"https://www.pixnet.net/#organization",
                    "description":"痞客邦職涯頻道，有網友們提供的職涯資訊、實用的就業技巧和職場心得分享。不論你是準備找工作、轉職還是尋求晉升，這裡有各種寶貴的建議和專家見解等待你的探索。加入我們，與一群志同道合的人們共同探索職場世界，實現職涯夢想！",
                    "address":"",
                    "brand":{
                        "@type":"Brand",
                        "logo":"https://www.pixnet.net/img/public/og/img_carrer_og.png"
                    },
                    "sameAs":"https://www.facebook.com/pixnet.net"
                },
                {
                    "@context":"https://schema.org/",
                    "@type":"BreadcrumbList",
                    "itemListElement":[
                        {
                            "@type": "ListItem",
                            "position": 1,
                            "name": "職涯-PIXNET痞客邦",
                            "item": "https://www.pixnet.net",
                            "description": "痞客邦職涯頻道，有網友們提供的職涯資訊、實用的就業技巧和職場心得分享。不論你是準備找工作、轉職還是尋求晉升，這裡有各種寶貴的建議和專家見解等待你的探索。加入我們，與一群志同道合的人們共同探索職場世界，實現職涯夢想！",
                            "keywords": "求職、職涯規劃、職場技巧、職業發展、升遷、職場競爭力、自我提升、轉職、職涯專業培訓、個人品牌、面試技巧、履歷撰寫、工作技能、領導力發展、創業、職業健康與幸福感、學習與成長、工作生涯規劃、行業洞察與趨勢、職場溝通技巧"
                        }
                    ]
                }
            ]
        }
    },
    data() {
        return {
            channel_page_id: 8,
            showAnimation: false,
        }
    },
    computed: {
        is_login() {
            return this.$store.state.login.login_status;
        },
        pa_page_name() {
            return '職涯';
        },
        tag_search_text() {
            return '職涯';
        },
        day_hot_article() {
            return this.$store.state.article.day_hot_article;
        },
        day_hot_article_full() {
            return this.$store.state.article.day_hot_article_full;
        }
    },
    methods: {
        paFunction() {
            window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'imps::頁面::page::user_action', '', '']);
        },
        paScrollFunction(){
            addEventListener("scroll", () => {
                window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'scroll::頁面::page::user_action', '', '']);
            }, { once: true });
        },
        gtag(){
            window.dataLayer.push(arguments);
        },
        activeGaPage() {
            this.gtag('config', 'G-RPGK0ML6QM', {
                'channel_category': '職涯'
            });
            this.gtag('config', 'G-45SMZ66RLZ', {
                'channel_category': '職涯'
            });
            this.gtag('event', 'page_view', {
                page_title: '職涯-PIXNET痞客邦',
            });
        },
        activeMcPage() {
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "kbvat69or6");
        },
    },
    async fetch(){
        const item = { sort: 'hot', type: 'group', pre_page: 10, id: 8, ver: 2 }
        await this.$store.dispatch("article/getDayHotArticle", item);
    },
    mounted() {
        window.dataLayer = window.dataLayer || [];
        this.activeGaPage();
        this.activeMcPage();
        this.paFunction();
        this.paScrollFunction();
    }
}
